import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

@Pipe({name: 'relativeTime', standalone: false})
export class RelativeTimePipe implements PipeTransform {
    transform(value: string | Date | null): string {
        if (!value) {
            return '';
        }

        const date = moment(value);
        if (!date.isValid()) {
            return '';
        }

        const now = moment();
        const diffDays = now.diff(date, 'days');

        if (diffDays === 0) {
            return $localize`:@@relativeTime.today:Heute`;
        } else if (diffDays === 1) {
            return $localize`:@@relativeTime.yesterday:Gestern`;
        } else if (diffDays <= 30) {
            return $localize`:@@relativeTime.daysAgo:Vor ${diffDays} Tagen`;
        } else {
            return $localize`:@@relativeTime.overAMonth:Vor über einem Monat`;
        }
    }
}
